import React from "react";
import { Route } from "react-router-dom";
//
import { URL } from "../url";
// component
import LayoutRoot from "../layout/layout_root";
import PrivateRoute from "../component/private_route";
//
import DevScreen from "screen/100_Dev/dev";
import TaskScreen from "screen/02_Task/task_screen";
import HistoryScreen from "screen/03_History/history";
//concept

const PERMISSION_SCREEN = "tl";

export const routerPrivate = () => {
  // -------------------------- STATE --------------------------

  // -------------------------- FUNCTION --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <Route exact path={URL.home} element={<LayoutRoot />}>
      <Route
        index
        element={
          <PrivateRoute
            require={[PERMISSION_SCREEN]}
            element={<TaskScreen />}
          />
        }
      />
      <Route
        path={URL.history}
        element={<PrivateRoute element={<HistoryScreen />} />}
      />
      <Route
        path={URL.dev}
        element={<PrivateRoute require={[]} element={<DevScreen />} />}
      />
    </Route>
  );
};
